<template>
    <DesignExamplesLayout>
        <router-view />
    </DesignExamplesLayout>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';

    import DesignExamplesLayout from './DesignExamplesLayout.vue';

    export default defineComponent({
        name: 'DesignExamplesComponents',
        components: { DesignExamplesLayout },
    });
</script>
